var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBring(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.28314 8.6048L3.17956 10.9171L4.87171 11.7247L6.15814 9.0293V1.44799H4.28314V8.6048Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5417 14.625V13.6506L10.1335 8.60481V1.448H8.25854V9.02931L10.6667 14.0751V14.625H12.5417Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9481 0.510498H3.46857V2.3855H10.9481V0.510498Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6667 14.625H12.5417L12.5417 14.0751L14.9497 9.02927V1.44797H13.0747V8.60479L10.6667 13.6506L10.6667 14.625Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3333 14.625V13.6506L18.9252 8.60482V1.448H17.0502V9.0293L19.4583 14.0751V14.625H21.3333Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7398 0.510498H12.2603V2.3855H19.7398V0.510498Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4583 14.625H21.3333L21.3333 14.0751L23.7414 9.02928V1.44797H21.8664V8.60478L19.4583 13.6506L19.4583 14.625Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.7169 8.60481L28.8204 10.9171L27.1283 11.7247L25.8419 9.02931V1.448H27.7169V8.60481Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5314 0.510498H21.0519V2.3855H28.5314V0.510498Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 32.5H32V9.93747H29.1875C27.6342 9.93747 26.375 11.1967 26.375 12.75V13.6875H5.625V12.75C5.625 11.1967 4.36577 9.93747 2.8125 9.93747H0V32.5ZM1.875 30.625V11.8125H2.8125C3.33023 11.8125 3.75 12.2322 3.75 12.75V15.5625H28.25V12.75C28.25 12.2322 28.6698 11.8125 29.1875 11.8125H30.125V30.625H1.875Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6962 28.4402H16.3039L22.6045 24.9651V21.7003L16.3333 17.7472H15.667L9.39549 21.7009V24.9652L15.6962 28.4402ZM16 26.4665L11.2705 23.858V22.7353L16.0002 19.7536L20.7295 22.7348V23.858L16 26.4665Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9877 7.99997H14.0123V9.87497H17.9877V7.99997Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9877 4.24997H14.0123V6.12497H17.9877V4.24997Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.7793 7.99997H22.804V9.87497H26.7793V7.99997Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.7793 4.24997H22.804V6.12497H26.7793V4.24997Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.25846 7.99997H5.28308V9.87497H9.25846V7.99997Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.25846 4.24997H5.28308V6.12497H9.25846V4.24997Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBring);
export default __webpack_public_path__ + "static/media/bring.5436dcce70de7d5d99d797f006af9e9f.svg";
export { ForwardRef as ReactComponent };